import handle_token_expired from '@/api/handle_token_expired.js'
import handle_session_already_active from '@/api/handle_session_already_active.js'

export default function (response, router, store) {
  handle_token_expired(response.status, router, store)
  handle_session_already_active(response, router, store)

  console.error(response)
}
